const formatMeetingDate = (dateString: string, locale: string): string => {
  const [yearString, monthString] = dateString.slice(0, 7).split('-');
  const date = new Date(Number(yearString), Number(monthString) - 1, 1);

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
  }).format(date);
};

export { formatMeetingDate };
